import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * DescriptionNote - renders an alert-style informational note banner.
 * @param {string} description - the text to display
 */
export default function DescriptionNote({ description }) {
  if (!description || !description.trim()) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        mb: 2.5,
        px: { xs: 2, sm: 3 },
        py: { xs: 1.5, sm: 2 },
        borderRadius: 3,
        background: "linear-gradient(135deg, #fffbeb 0%, #fefce8 100%)",
        border: "1.5px solid #f5c842",
        boxShadow: "0 2px 10px rgba(245, 200, 66, 0.13)",
        animation: "noteFadeIn 0.5s ease both",
        "@keyframes noteFadeIn": {
          from: { opacity: 0, transform: "translateY(-8px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      <InfoOutlinedIcon
        sx={{
          color: "#d4a200",
          fontSize: { xs: 20, sm: 22 },
          mt: 0.3,
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          color: "#7a5c00",
          fontSize: { xs: 13, sm: 14 },
          fontWeight: 500,
          lineHeight: 1.65,
          whiteSpace: "pre-line",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}
